import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/whatsapp.svg"
import { Form } from "../Form/Form";


export function Contact(){

  return(
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>Ready to get started with us? </p>
        <p>Contact us now !</p>
      </header>
      <div className="contacts">
        <div>
        <a href="mailto:collab@funkeycreators.com"><img src={emailIcon} alt="Email" /></a> 
          <a href="mailto:collab@funkeycreators.com">collab@funkeycreators.com</a>
        </div>
        
      </div>
      <Form></Form>
    </Container>
  )
}